<template>
  <div :class="$style.picker__grid" :style="`--themeColor: ${themeColor}`">
    <TrailBodyBackground 
      v-if="trail" 
      :background="trail.background_style" />
      
    <LoadingContainer v-if="!trail" />

    <transition name="fade">
      <TrailDetails
        v-if="trail"
        :key="trail.id"
        :trail="trail"
        @prev="prevTrail"
        @next="nextTrail"
      />
    </transition>
  </div>
</template>

<script>
import { computed, ref, watch } from '@vue/composition-api'
import TrailDetails from './TrailDetails'
import { getTrailIndex } from '@/api/trail'
import LoadingContainer from '@/components/layout/LoadingContainer'
import TrailBodyBackground from './TrailBodyBackground'

export default {
  name: 'TrailPicker',
  components: {
    TrailDetails,
    LoadingContainer,
    TrailBodyBackground,
  },
  props: {
    slug: {
      type: String,
      default: null
    }
  },
  setup (props) {
    const trails = ref([])
    const trailPickedIndex = ref(0)
    const trailsLoaded = ref(false)

    const loadTrails = async () => {
      if (!trailsLoaded.value) {
        trails.value = await getTrailIndex()
        trailsLoaded.value = true
      }

      // Se slug for fornecido, encontra o índice do trail correspondente
      if (props.slug && trails.value.length > 0) {
        const index = trails.value.findIndex(trail => trail.slug === props.slug)
        if (index !== -1) {
          trailPickedIndex.value = index
        }
      }
    }

    watch(() => props.slug, loadTrails, { immediate: true })

    const themeColor = computed(() => {
      const trail = trails.value[trailPickedIndex.value]
      return trail ? trail.color : '#FCB045'
    })

    const trail = computed(() => {
      const trail = trails.value[trailPickedIndex.value]
      return trail ? trail : null
    })

    const pickTrail = (index) => trailPickedIndex.value = index

    const prevTrail = () => {
      trailPickedIndex.value = !trailPickedIndex.value ? trails.value.length - 1 : trailPickedIndex.value - 1
    }

    const nextTrail = () => {
      trailPickedIndex.value = trailPickedIndex.value == trails.value.length - 1 ? 0 : trailPickedIndex.value + 1
    }

    return {
      themeColor,
      pickTrail,
      trails,
      trailPickedIndex,
      trail,
      prevTrail,
      nextTrail,
    }
  }
}
</script>

<style module lang="scss">
  @import "~@/components/trail/trail.scss";

  /* Fade transition */
  :global(.fade-enter-active), :global(.fade-leave-active) {
    transition: opacity 0.2s;
  }
  :global(.fade-enter-from), :global(.fade-leave-to) {
    opacity: 0;
  }
  :global(.fade-enter-to), :global(.fade-leave-from) {
    opacity: 1;
  }
</style>